import { render, staticRenderFns } from "./ServersLogs.vue?vue&type=template&id=bc86d2ac&"
import script from "./ServersLogs.vue?vue&type=script&lang=js&"
export * from "./ServersLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports